export default "__VITE_ASSET__2e778c91__"